import React, { useEffect, useState } from 'react';
import axios from "../axiosConfig";
import TasksTable from '../components/TasksTable';
import PageTitle from "../components/PageTitle";

const Tasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  // Get current user from localStorage
  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch {
      return null;
    }
  })();

  const defaultParticipants = [{
    id: user.user_contact_id,
    type: "contact",
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
    is_sender: false,
  }];

  return (
    <div className="page-layout">
      <PageTitle>All Tasks</PageTitle>
      
      <div className="page-content">
        <TasksTable 
          defaultParticipants={defaultParticipants} 
          onInteractionCreated={() => {}} 
          fillPage
        />
      </div>
    </div>
  );
};

export default Tasks;
